import React from "react";
import "./MobileStateComponent.css";
import { FiCalendar, FiX } from "react-icons/fi";
import BookingCarouselMobileState from "./BookingCarouselMobileState";
import { Link } from "react-router-dom";


// const bookings = [
//   {
//     date: "11-4-25",
//     time: "10 PM",
//     package: "IMFL + FOOD",
//     people: 10,
//     title: "Group Booking",
//     status: "Waiting For Bids",
//     progress: 49,
//   },
//   {
//     date: "12-4-25",
//     time: "09 PM",
//     package: "Drinks Only",
//     people: 6,
//     title: "Birthday Party",
//     status: "Waiting For Bids",
//     progress: 65,
//   },
// ];

export default function MobileStateComponent({ stateType, PreState, combinedLeads = [] }) {

        console.log("bookings", combinedLeads);



    if (stateType === "LoginRequiredState") {
        return (
            <div className="mobile-state-component-login-box mb-1">
                <span className="mobile-state-component-login-text">
                    Login required to continue
                </span>
                <div className="mobile-state-component-login-action">
                     <Link to="/login">
                    <button className="mobile-state-component-login-btn">
                        <span className="mobile-state-component-login-icon">🔑</span>
                        <span className="mobile-state-component-login-btn-text">
                            Hello! <br /> Please Sign In
                        </span>
                    </button>
                     </Link>
                    {/* <span className="mobile-state-component-close-btn">✕</span> */}
                </div>
            </div>
        );
    }

    if (stateType === "Nolead") {
        return (
            <div className="booking-box mb-1">
                <div className="booking-left">
                    <div className="booking-icon">
                        <FiCalendar size={20} />
                    </div>
                    <div className="booking-text">
                        <p className="booking-title">Nothing Booked Yet.</p>
                        <p className="booking-subtitle">Let’s Change That.</p>
                    </div>
                </div>

                <div className="booking-right">
                    <Link to="/my-plan">
                    <button  className="booking-btn">Start Party Planning</button>
                    </Link>
                    {/* <span className="booking-close">
                        <FiX size={18} />
                    </span> */}
                </div>
            </div>
    );
    }
    if(stateType === "LeadBidSate"){ {
        return (
            <BookingCarouselMobileState combinedLeads={combinedLeads}  PreState={PreState}/>
        );
    }
    }

    return null; // if no matching state
}

